import posthog from "posthog-js";
import { postOverallFeedback } from "@elevenlabs/client";

const TEXT_PREVIEW_MAX = 300;

function previewText(text) {
  const raw = String(text || "").trim();
  if (!raw) return "";
  if (raw.length <= TEXT_PREVIEW_MAX) return raw;
  return `${raw.slice(0, TEXT_PREVIEW_MAX)}…`;
}

/** Safe PostHog capture for onboarding assistant events. */
export function captureAssistantEvent(eventName, properties = {}) {
  try {
    posthog?.capture?.(eventName, properties);
  } catch {
    /* ignore analytics failures */
  }
}

export function messageProps(text) {
  const raw = String(text || "");
  return {
    text_length: raw.trim().length,
    text_preview: previewText(raw),
  };
}

/** Summarize a client-tool JSON string result without dumping huge payloads. */
export function summarizeToolResult(result) {
  if (result == null) return { ok: true };
  let parsed = result;
  if (typeof result === "string") {
    try {
      parsed = JSON.parse(result);
    } catch {
      return {
        ok: !/error/i.test(result),
        result_preview: previewText(result),
      };
    }
  }
  if (!parsed || typeof parsed !== "object") {
    return { ok: true };
  }
  const summary = {
    ok: !parsed.error && parsed.ok !== false,
  };
  if (parsed.error) summary.error = String(parsed.error).slice(0, 200);
  if (parsed.path) summary.path = parsed.path;
  if (parsed.applied != null) summary.applied = Boolean(parsed.applied);
  if (parsed.drafted?.primaryAction) {
    summary.primary_action = parsed.drafted.primaryAction;
  }
  if (parsed.drafted?.ivrMenu) summary.has_ivr_menu = true;
  return summary;
}

/**
 * Conversation-level like/dislike for the ElevenLabs dashboard
 * (POST /v1/convai/conversations/{id}/feedback). Fire-and-forget.
 */
export function sendElevenLabsOverallFeedback(conversationId, like) {
  if (!conversationId || typeof like !== "boolean") return;
  try {
    void postOverallFeedback(conversationId, like).catch(() => {
      /* ignore */
    });
  } catch {
    /* ignore */
  }
}
